<template>
  <div>
    <common-list
      ref="list"
      url="LogLogin/GetList"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
        <el-form-item label="登录名" prop="LoginName">
          <el-input
            v-model.trim="filter.LoginName"
            placeholder="登录名"
            clearable
          ></el-input>
        </el-form-item>
      </el-col>
      </template>

      <template v-slot:body>
        <el-table-column
          label="登录名"
          prop="LoginName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="IP"
          prop="Ip"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="登录时间">
          <template v-slot="{ row }">
            <span>{{ row.CreatedTime | datetime("YYYY-MM-DD HH:mm:ss") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结果">
          <template v-slot="{ row }">
            <span>{{ row.LoginResult == "1" ? "成功" : "失败" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="描述"
          prop="Remark"
          show-overflow-tooltip
        ></el-table-column>
      </template>
    </common-list>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style>
</style>